<template>
  <v-card max-width="1000px" style="margin-left:auto;margin-right:auto">
    <v-card-title primary-title>
      <div>
        <h3 class="headline mb-0">{{$t('views.register.register')}}</h3>
      </div>
    </v-card-title>
    <v-form ref="form" v-model="valid" v-show="validToken">
      <v-container fluid grid-list-md>
        <v-layout row wrap>
          <v-col cols="12" sm="6" md="3" class="pt-0 pb-0">
            <v-select
              :disabled="true"
              ref="brokers"
              v-model="user.Broker"
              :items="brokers"
              :label="$t('globals.broker')"
              :return-object="true"
              item-text="Name"
              item-value="Id"
            ></v-select>
          </v-col>
          <v-col cols="12" sm="6" md="3" class="pt-0 pb-0">
            <v-select
              :disabled="true"
              v-model="userRoles"
              :items="roles"
              :label="$t('views.register.role')"
              multiple
              :return-object="true"
              item-text="Name"
              item-value="Id"
            ></v-select>
          </v-col>
          <v-col cols="12" sm="6" md="3" class="pt-0 pb-0">
            <v-select
              :disabled="true"
              v-model="user.Plans"
              :items="plans"
              :label="$t('globals.plans')"
              multiple
              item-text="Name"
              item-value="Id"
              :return-object="true"
            ></v-select>
          </v-col>
          <v-col cols="12" sm="6" md="3" class="pt-0 pb-0">
            <v-autocomplete
              :disabled="true"
              v-model="user.Employers"
              :items="employers"
              :label="$t('globals.employers')"
              item-text="Name"
              item-value="Id"
              return-object
              multiple
              validate-on-blur
            ></v-autocomplete>
          </v-col>
          <v-col cols="12" sm="6" md="3" class="pt-0 pb-0">
            <v-autocomplete
              :disabled="true"
              v-model="user.Stores"
              :items="stores"
              :label="$t('globals.stores')"
              item-text="Name"
              item-value="Id"
              return-object
              multiple
              validate-on-blur
            ></v-autocomplete>
          </v-col>
          <v-col cols="12" sm="6" md="3" class="pt-0 pb-0">
            <no-autocomplete-textfield ref="email" :disabled="true" v-model="user.Email" :label="$t('headers.contacts.email')"></no-autocomplete-textfield>
          </v-col>
          <v-col cols="12" sm="6" class="pt-0 pb-0">
            <no-autocomplete-textfield
              v-model="user.FirstName"
              :rules="[$rules.required, $rules.validName]"
              :label="$t('globals.firstname')"
              validate-on-blur
              class="required"
            ></no-autocomplete-textfield>
          </v-col>
          <v-col cols="12" sm="6" class="pt-0 pb-0">
            <no-autocomplete-textfield
              ref="lastName"
              v-model="user.LastName"
              :rules="[$rules.required, $rules.validLastName]"
              :label="$t('globals.lastname')"
              validate-on-blur
              class="required"
            ></no-autocomplete-textfield>
          </v-col>
          <v-col cols="12" sm="6" class="pt-0 pb-0">
            <no-autocomplete-textfield
              ref="password"
              autocomplete="new-password"
              v-model="user.Password"
              :type="'password'"
              :rules="$rules.passwordRules"
              :label="$t('views.firstlogin.password')"
              validate-on-blur
            ></no-autocomplete-textfield>
          </v-col>
          <v-col cols="12" sm="6" class="pt-0 pb-0">
            <no-autocomplete-textfield
              ref="confirmPassword"
              autocomplete="new-password"
              v-model="user.ConfirmPassword"
              :type="'password'"
              :rules="confirmPasswordRules"
              :label="$t('views.firstlogin.password_confirmation')"
              validate-on-blur
            ></no-autocomplete-textfield>
          </v-col>
          <v-col cols="12" sm="12" class="pt-0 pb-0">
            <v-checkbox
              v-model="agree"
              :rules="[$rules.required]"
              class="required"
            >
              <template slot="label">
                {{$t("globals.agree_terms_conditions1")}}<a style="margin-left:5px;margin-right:5px;" href="/#/terms-conditions" target="_blank">{{$t("globals.agree_terms_conditions2")}}</a> {{$t("globals.agree_terms_conditions3")}} <a style="margin-left:5px;margin-right:5px;" href="/#/privacy-policy" target="_blank">{{$t("globals.agree_terms_conditions4")}}</a>
              </template>
            </v-checkbox>
          </v-col>
          <v-col cols="12" sm="6" class="pt-0 pb-0">
            <vue-recaptcha
              v-on:expired="recaptchaValid=false"
              v-on:verify="recaptchaCallback($event)"
              :sitekey="settings.SiteKey"
            ></vue-recaptcha>
          </v-col>
        </v-layout>
      </v-container>
    </v-form>
    <v-card-actions>
      <v-btn :disabled="!valid || !recaptchaValid" :loading="saving" color="primary" @click="handleSubmit()">{{$t('views.register.register')}}</v-btn>
    </v-card-actions>
    <v-snackbar
      v-model="snackbar"
      :color="color"
      :multi-line="mode === 'multi-line'"
      :timeout="timeout"
      :vertical="mode === 'vertical'"
    >
      {{$t(message)}}
      <v-btn dark text @click="snackbar = false">{{$t('globals.close')}}</v-btn>
    </v-snackbar>
    <error-handler :error="error"></error-handler>
  </v-card>
</template>


<script>
import VueRecaptcha from "vue-recaptcha";
import { mapGetters, mapActions } from "vuex";
import jwt from "jsonwebtoken";
import ErrorHandler from "../components/ErrorHandler";
import NoAutocompleteTextfield from "../components/NoAutocompleteTextfield";
import { sortAlphanum } from "../alphanumericSort";

export default {
  name: "register",
  data() {
    return {
      agree: false,
      validToken: false,
      error: null,
      saving:false,
      userRoles:[],
      snackbar: false,
      color: "",
      mode: "",
      timeout: 2500,
      message: "",
      recaptchaValid: false,
      brokers: [],
      roles: [],
      plans: [],
      employers:[],
      stores:[],
      valid: true,
      confirmPasswordRules: [
        v => (v && v === this.user.Password) || this.$t("validation.passwords_do_not_match")
      ],
      user: {}
    };
  },
  watch: {
    agree:{
      handler(v) {
        console.log(this.valid, this.agree, v);
      }
    }
  },
  computed: {
    ...mapGetters("common", ["settings", "language"])
  },
  mounted() {
    var token = this.$route.params.token;
    try {
      var decoded = jwt.verify(token, this.settings.RegistrationTokenSecret);
      this.validToken = true;
      this.brokers = [decoded.broker];
      this.roles = decoded.roles;
      this.user.Broker = decoded.broker;
      this.userRoles = decoded.roles;
      this.user.Email = decoded.email;
      let plans = decoded.plans.sort((a, b) => {
        const translatedA =  a.Translations.filter(
            (o) => o.LanguageCode === this.language.language
          )[0].Name;
        const translatedB = b.Translations.filter(
            (o) => o.LanguageCode === this.language.language
          )[0].Name;
        return sortAlphanum(translatedA, translatedB);
      });
      this.plans = plans;
      this.user.Plans = plans;
      let employers = decoded.employers.sort((a, b) => {
              const translatedA =  a.Translations.filter(
                  (o) => o.LanguageCode === this.language.language
                )[0].Name;
              const translatedB = b.Translations.filter(
                  (o) => o.LanguageCode === this.language.language
                )[0].Name;
              return sortAlphanum(translatedA, translatedB);
            });
      this.employers = employers;
      this.user.Employers = employers;
      this.stores = decoded.stores;
      this.user.Stores = decoded.stores;
      this.user.IsActive = decoded.IsActive;
    } catch (err) {
      console.log("ERROR: ", err);
      this.error = err;
    }
  },
  methods: {
    /*$t(args) {
        console.log(this.messages, args)
        if (Object.keys(this.messages).indexOf(args) < 0) {
            this.messages[args]="TRANSLATION REQUIRED"
        }
        return "TRANSLATION REQUIRED";
    },*/
    ...mapActions("applicationUsers", ["newUser"]),
    recaptchaCallback() {
      // console.log("recaptcah valid")
      this.recaptchaValid = true;
    },
    async handleSubmit() {
      this.saving = true
      //console.log("REGISTER: ", this.user)
      this.user.UserName = this.user.Email;

      this.user.BrokerId = this.user.Broker.Id;

      this.user.IsConfirmed = true;

      this.user.Roles = [];
      this.roles.forEach(role => {
        this.user.Roles.push({
          RoleId: role.Id
        });
      });

      try {
        await this.newUser({broker:this.user.Broker.Id, user:this.user});
        this.color = "success";
        this.message = "globals.success";
        this.snackbar = true;
        this.$router.push({ name: "home" });
      } catch (error) {
        this.error = error;
      }
      this.saving = false
    },
    validate() {
      if (this.$refs.form.validate()) {
        return true;
      }
      return false;
    }
  },
  components: { VueRecaptcha, ErrorHandler, NoAutocompleteTextfield }
};
</script>